import api from '~/api';
import { GetDocumentLinkResponse } from '../dtos/signDocumentsResponse';

export const getDocumentLink = async (
  partnerId: string,
  partnerUserId: string,
  signal: AbortSignal
): Promise<string> => {
  const { data } = await api.getAsync<GetDocumentLinkResponse | undefined>(
    `/v2/partner/${partnerId}/user/${partnerUserId}/agreement`,
    { signal }
  );

  return data?.link || '';
};

export const signDocument = async (partnerId: string): Promise<void> => {
  await api.post(`/v2/partner/${partnerId}/agreement_confirmation`);
};
